<suite-rfb-collapse title="Informações Complementares" collapsed="true">
  <via-cafir [ni]="cnpj"></via-cafir>

  <via-comprot [cnpj]="cnpj"></via-comprot>

  <via-acao-fiscal [cnpj]="cnpj"></via-acao-fiscal>
</suite-rfb-collapse>
